"use strict";

require("core-js/modules/es.string.trim");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.Device = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactMedia = _interopRequireDefault(require("react-media"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Device = function Device(_ref) {
  var mobile = _ref.mobile,
      tablet = _ref.tablet,
      desktop = _ref.desktop,
      breakpoints = _ref.breakpoints,
      children = _ref.children;
  var maxWidth;
  var minWidth;

  if (mobile) {
    minWidth = 0;
    maxWidth = 480;
  }

  if (tablet) {
    minWidth = 0 <= minWidth ? minWidth : 480 + 1;
    maxWidth = 992;
  }

  if (desktop) {
    minWidth = 0 <= minWidth ? minWidth : 992 + 1;
    maxWidth = void 0;
  } //force breakpoints, overrides mobile, tablet & desktop only tags


  if (breakpoints && (null !== breakpoints.min || null !== breakpoints.max)) {
    minWidth = breakpoints.min || 0;
    maxWidth = breakpoints.max ? breakpoints.max - 1 : void 0;
  }

  var minWidthQuery = minWidth ? "(min-width: " + minWidth + "px)" : "";
  var maxWidthQuery = maxWidth ? "(max-width: " + maxWidth + "px)" : "";
  var separator = minWidthQuery && maxWidthQuery ? "and" : "";
  return /*#__PURE__*/_react.default.createElement(_reactMedia.default, {
    query: (minWidthQuery + " " + separator + " " + maxWidthQuery).trim(),
    render: function render() {
      return children;
    }
  });
};

exports.Device = Device;
Device.propTypes = {
  mobile: _propTypes.default.bool,
  tablet: _propTypes.default.bool,
  desktop: _propTypes.default.bool,
  breakpoints: _propTypes.default.object,
  children: _propTypes.default.node
};